import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import { LoginComponent } from "../components/login/loginComponent";


const LoginModal: React.FC<any> = ({ open, onClose }) => {

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <Dialog
                sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 600, borderRadius: 6, backgroundColor: "#f5f5f5" } }}
                maxWidth="md"
                open={open}
                onClose={handleClose}
            >
                {/* <DialogTitle sx={{ color: 'Black', textAlign: 'center' }}>Login</DialogTitle> */}
                <DialogContent sx={{ justifyContent: 'center', display: 'flex' }}>
                    <LoginComponent isRedirect={false} handleSubmit={handleClose} />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default LoginModal;
